import { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { FaPlus, FaTimes } from "react-icons/fa";
import { uploadAccept } from "../../utilities/importantFns";

const PRIMARY = "#0F2A6B";

export const AddPickupForm = ({
  form,
  deleteEmergencyContact,
  pickups,
  addPickup,
  numberOfPickups,
  handlePickupSubmit,
  handlePickupChange,
}: any) => {
  const [isClicked, setIsClicked] = useState(false);

  function removeFormPickup(index: number) {
    addPickup((prev: any) => prev.filter((_: any, i: number) => i !== index));
  }

  return (
    <div className="bg-blue-50 p-6 rounded-2xl">
      <form
        onSubmit={(e: any) => {
          e.preventDefault();
          handlePickupSubmit();
          setIsClicked(true);
        }}
        className="space-y-6"
      >
        {/* EXISTING CONTACTS */}
        {numberOfPickups > 0 && (
          <div className="grid md:grid-cols-2 gap-4">
            {pickups?.map((item: any, index: number) => (
              <div
                key={index}
                className="relative bg-white rounded-2xl p-4 border
                shadow-[0_10px_30px_rgba(0,0,0,0.12)]
                hover:shadow-[0_20px_50px_rgba(15,42,107,0.18)]
                transition-all duration-300 flex gap-4 items-center"
              >
                {/* REMOVE BUTTON */}
                <button
                  type="button"
                  onClick={() => deleteEmergencyContact(item.id)}
                  className="absolute top-3 right-3 bg-red-500 text-white p-1.5 rounded-full shadow-md hover:scale-105 transition"
                >
                  <FaTimes size={10} />
                </button>

                <img
                  src={item.photo}
                  className="h-16 w-16 rounded-full object-cover border"
                />

                <div>
                  <p className="font-semibold text-gray-800">
                    {item.contact_name}
                  </p>
                  <p className="text-xs text-gray-500">{item.relationship}</p>
                  <p className="text-sm text-gray-700">{item.phone}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* TITLE */}
        {numberOfPickups < 2 && (
          <h2 className="text-sm font-semibold text-gray-700">
            Emergency Contact
          </h2>
        )}

        {/* FORM */}
        {numberOfPickups < 2 ? (
          form?.map((contact: any, index: number) => (
            <div
              key={index}
              className="relative bg-white rounded-2xl p-5 border
              shadow-[0_10px_30px_rgba(0,0,0,0.12)]
              hover:shadow-[0_20px_50px_rgba(15,42,107,0.18)]
              transition-all duration-300 space-y-4"
            >
              {/* REMOVE ICON (TOP RIGHT) */}
              {index > 0 && (
                <button
                  type="button"
                  onClick={() => removeFormPickup(index)}
                  className="absolute top-3 right-3 bg-red-500 text-white p-1.5 rounded-full shadow-md hover:scale-105 transition"
                >
                  <FaTimes size={10} />
                </button>
              )}

              {/* HEADER */}
              <h3 className="text-sm font-semibold text-gray-700">
                Contact {index + numberOfPickups + 1}
              </h3>

              {/* CONTENT */}
              <div className="flex gap-6 flex-col md:flex-row">
                {/* IMAGE */}
                <div className="relative">
                  <label className="cursor-pointer">
                    <input
	                      type="file"
	                      name="photo"
	                      accept={uploadAccept.image}
	                      className="hidden"
                      onChange={(e) => handlePickupChange(index, e)}
                    />

                    <div
                      className="w-24 h-24 rounded-full overflow-hidden border
                      shadow-[0_6px_20px_rgba(0,0,0,0.15)]
                      hover:shadow-[0_12px_30px_rgba(15,42,107,0.25)]
                      transition-all duration-300 relative group"
                    >
                      {contact.photo ? (
                        <img
                          src={URL.createObjectURL(contact.photo)}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="flex items-center justify-center h-full bg-gray-100">
                          <AiOutlinePlus className="text-gray-400 text-xl" />
                        </div>
                      )}

                      {/* OVERLAY */}
                      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center text-white text-xs transition">
                        Change
                      </div>
                    </div>
                  </label>
                </div>

                {/* INPUTS */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 flex-1">
                  <Input
                    label="Full Name"
                    name="contact_name"
                    value={contact.contact_name}
                    onChange={(e: any) => handlePickupChange(index, e)}
                  />

                  <Input
                    label="Phone"
                    name="phone"
                    value={contact.phone}
                    onChange={(e: any) => handlePickupChange(index, e)}
                  />

                  <select
                    name="relationship"
                    value={contact.relationship}
                    onChange={(e) => handlePickupChange(index, e)}
                    className="input"
                  >
                    <option value="">Relationship</option>
                    <option>Father</option>
                    <option>Mother</option>
                    <option>Sister</option>
                    <option>Brother</option>
                    <option>Uncle</option>
                    <option>Aunty</option>
                    <option>Nanny</option>
                    <option>Grandma</option>
                    <option>Grandpa</option>
                    <option>Others</option>
                  </select>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center text-green-800 font-semibold">
            Emergency Contact limit reached!
          </div>
        )}

        {/* ADD BUTTON */}
        {form?.length + numberOfPickups < 2 && numberOfPickups < 2 && (
          <div className="flex justify-center">
            <div
              onClick={() =>
                addPickup((prev: any) => [
                  ...prev,
                  {
                    contact_name: "",
                    phone: "",
                    relationship: "",
                    photo: "",
                  },
                ])
              }
              className="
        w-full max-w-sm h-32
        flex flex-col items-center justify-center gap-2
        bg-white border-2 border-dashed border-gray-300
        rounded-2xl cursor-pointer
        shadow-[0_10px_30px_rgba(0,0,0,0.1)]
        hover:shadow-[0_20px_50px_rgba(15,42,107,0.2)]
        hover:border-blue-400
        transition-all duration-300
        group
      "
            >
              <div
                className="
          w-12 h-12 rounded-full flex items-center justify-center
          bg-blue-50 text-blue-700
          group-hover:scale-110 transition
        "
              >
                <FaPlus size={18} />
              </div>

              <p className="text-sm text-gray-600 font-medium">Add Contact</p>
            </div>
          </div>
        )}

        {/* SUBMIT */}
        {numberOfPickups < 2 && (
          <div className="flex justify-end">
            <button
              type="submit"
              disabled={isClicked}
              className={`px-6 py-2.5 rounded-lg text-white
              shadow-[0_10px_30px_rgba(15,42,107,0.25)]
              hover:shadow-[0_15px_40px_rgba(15,42,107,0.35)]
              transition ${isClicked ? "opacity-50" : ""}`}
              style={{ backgroundColor: PRIMARY }}
            >
              Save Changes
            </button>
          </div>
        )}
      </form>
    </div>
  );
};

/* ================= INPUT ================= */

const Input = ({ label, ...props }: any) => (
  <div>
    <label className="text-xs text-gray-500">{label}</label>
    <input {...props} className="input" />
  </div>
);

/* ================= STYLE ================= */

const styles = `
.input {
  width: 100%;
  margin-top: 4px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  outline: none;
}
.input:focus {
  border-color: #0F2A6B;
  box-shadow: 0 0 0 2px rgba(15,42,107,0.1);
}
`;

if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.innerHTML = styles;
  document.head.appendChild(style);
}
